export default {"src":"/_next/static/media/ht.a7a5ae0c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};